import { Rule } from '@travelnest/merlin.rule';
import * as React from 'react';

interface ISectionHeaderProps {
	title: string;
}

export const SectionHeader: React.FunctionComponent<ISectionHeaderProps> = (props) => {
	return <div className="section-header">
		<h1 className="section-header__title-text">{props.title}</h1>
		<Rule />
	</div>;
};
